import { GraphQLReactWS } from '@soundxyz/graphql-react-ws';
import { graphqlClientHeaders } from '@context/headers';
import { GATEWAY_API_WS_URL } from '@utils/env';

export const {
  useSubscription,
  subscriptionStores,
  Effects: SubscriptionEffects,
} = GraphQLReactWS({
  graphqlWsOptions: {
    url: GATEWAY_API_WS_URL.href,
    connectionParams() {
      return {
        ...graphqlClientHeaders,
      };
    },
  },
});

export type {
  ExecutionResultWithData,
  ExecutionResultWithErrors,
  OnData,
  OnError,
} from '@soundxyz/graphql-react-ws';
